import Vue from 'vue';

export enum AnnouncementEventBusEvent {
  FocusInteractable = 'focus-interactable',
  FocusCloseButton = 'focus-close-button',
}

export const AnnouncementEventBus = new Vue();
